import React, { useState, useEffect, FC } from "react";
import { Box, Typography, Stack, Button, InputLabel } from "@mui/material";

import {
  btnApple,
  btnGoogle,
  btnStyOne,
  line,
  lineText,
} from "../ui-elements/styles-button";
import { Image } from "@mui/icons-material";
import { InputCustom } from "../ui-elements/input-ui";
import { labelSty } from "../ui-elements/styles-input";
import CustomDatePicker from "../ui-elements/date-picker";
import { Dayjs } from "dayjs";
import SelectInput from "../ui-elements/select";
import { RespsOne } from "../../interface/onboard";
import { formatDateFromString } from "../../utils/date-setup";
import { RequiredIcon } from "../ui-elements/svg-icons";
import {
  getConstituents,
  getDistrict,
  getLgaById,
  getParty,
  getPosition,
  getStates,
  SelectOption,
} from "../../utils/adhoc-request";
import { resps_validate } from "../../validate/onboarding";
import { useNotificationService } from "../../hooks/notification";
import useResponsive from "../../hooks/useResponsive";

export const RepsOne = ({ next, resp_data, setResp_data }: RespsOne) => {
  const { showNotification } = useNotificationService();
  const isMedium = useResponsive("down", "md", "xl");
  const [selectedDate, setSelectedDate] = useState<Dayjs | null>(null);
  const [social_links, setSocial_Links] = useState({
    value_1: "",
    value_2: "",
    value_3: "",
  });
  const [select_option, setSelect_option] = useState<{
    states: SelectOption[];
    state_id: string;
    lga: SelectOption[];
    lga_id: string;
    position: SelectOption[];
    position_id: string;
    district: SelectOption[];
    district_id: string;
    constituent: SelectOption[];
    constituency_id: string;
    party_id: string;
    party: SelectOption[];
  }>({
    states: [],
    state_id: "",
    lga: [],
    lga_id: "",
    position: [],
    position_id: "",
    district: [],
    district_id: "",
    constituent: [],
    constituency_id: "",
    party_id: "",
    party: [],
  });

  const fetch_position = async () => {
    try {
      const position_data = await getPosition();
      setSelect_option((prev) => ({ ...prev, position: position_data }));
    } finally {
    }
  };
  const fetch_parties = async () => {
    try {
      const position_data = await getParty();
      setSelect_option((prev) => ({ ...prev, party: position_data }));
    } finally {
    }
  };
  const fetch_states = async () => {
    try {
      const states_data = await getStates();
      setSelect_option((prev) => ({ ...prev, states: states_data }));
    } finally {
    }
  };
  const fetch_lga = async () => {
    try {
      const lga_data = await getLgaById(resp_data?.state_id);
      setSelect_option((prev) => ({ ...prev, lga: lga_data }));
    } finally {
    }
  };
  const fetch_district = async () => {
    try {
      const district_data = await getDistrict(resp_data?.state_id);
      setSelect_option((prev) => ({ ...prev, district: district_data }));
    } finally {
    }
  };
  const fetch_constituent = async () => {
    try {
      const constituent_data = await getConstituents(resp_data?.state_id);
      setSelect_option((prev) => ({ ...prev, constituent: constituent_data }));
    } finally {
    }
  };

  useEffect(() => {
    if (select_option?.states.length === 0) {
      fetch_states();
      fetch_position();
      fetch_parties();
    }
    if (resp_data?.state_id != "") {
      fetch_lga();
      fetch_district();
      fetch_constituent();
    }
  }, [resp_data?.state_id]);

  const on_submit = async () => {
    setResp_data((prev) => ({
      ...prev,
      social_handles: [
        social_links?.value_1,
        social_links?.value_2,
        social_links?.value_3,
      ],
    }));
    // validate the inputs
    const { bool, text } = resps_validate(resp_data);
    if (!bool) {
      showNotification(text, "warning");
      return;
    }
    next();
  };

  // const handle_date = (newValue: Dayjs | null) => {
  //   if (!newValue) return;
  //   setSelectedDate(newValue);
  //   const data_sworn = formatDateFromString(newValue);
  //   setResp_data((prev) => ({ ...prev, sworn_in_date: data_sworn }));
  // };
  const handle_date = (newValue: Dayjs | null) => {
    if (!newValue) return;
    setSelectedDate(newValue);
    const date = new Date(newValue.toString());
    const formattedDate =
      date.getFullYear() +
      "-" +
      String(date.getMonth() + 1).padStart(2, "0") +
      "-" +
      String(date.getDate()).padStart(2, "0");

    setResp_data((prev) => ({ ...prev, sworn_in_date: formattedDate }));
  };
  // handle position
  const handle_position = (id: string) => {
    setResp_data((prev) => ({ ...prev, position_id: id.toString() }));
    setSelect_option((prev) => ({ ...prev, position_id: id }));
  };
  // handle party
  const handle_party = (id: string) => {
    setResp_data((prev) => ({ ...prev, party_id: id.toString() }));
    setSelect_option((prev) => ({ ...prev, party_id: id }));
  };
  // handle district and constituent
  const handle_district = (id: string) => {
    setResp_data((prev) => ({
      ...prev,
      district_id: id.toString(),
    }));
    setSelect_option((prev) => ({ ...prev, district_id: id }));
  };
  // handle  constituent
  const handle_constituent = (id: string) => {
    setResp_data((prev) => ({
      ...prev,
      constituency_id: id.toString(),
    }));
    setSelect_option((prev) => ({ ...prev, constituency_id: id }));
  };
  // handle states
  const handle_state = (id: string) => {
    setResp_data((prev) => ({ ...prev, state_id: id.toString() }));
    setSelect_option((prev) => ({ ...prev, state_id: id }));
  };
  // handle lga
  const handle_lga = (id: string) => {
    setResp_data((prev) => ({ ...prev, local_government_id: id.toString() }));
    setSelect_option((prev) => ({ ...prev, lga_id: id }));
  };

  return (
    <Box sx={{ width: isMedium ? "100%" : 620, mx: "auto" }}>
      <Box sx={{ my: 2 }}>
        <Typography
          variant="h3"
          sx={{
            fontWeight: 500,
            color: "#26203B",
            textAlign: "center",
          }}
        >
          Set Up Your Representative Profile
        </Typography>
        <Typography
          variant="subtitle1"
          sx={{
            fontWeight: 400,
            color: "#9C9AA5",
            textAlign: "center",
            width: "90%",
            mx: "auto",
          }}
        >
          Answer a few quick questions to help us tailor your experience and
          connect you with your constituents effectively.
        </Typography>
      </Box>
      <Box sx={{ width: isMedium ? "90%" : "80%", mx: "auto" }}>
        <Stack sx={{ width: "100%", my: 2 }}>
          <InputLabel sx={{ ...labelSty }}>
            What is your official title and office position? <RequiredIcon />
          </InputLabel>
          <SelectInput
            value={select_option?.position_id}
            onChange={(e: any) => handle_position(e.target.value)}
            options={select_option?.position}
          />
        </Stack>
        <Stack sx={{ my: 2 }}>
          <InputLabel sx={{ ...labelSty }}>
            What’s your state of primary residence? <RequiredIcon />
          </InputLabel>
          <SelectInput
            value={select_option.state_id}
            onChange={(e) => handle_state(e.target.value)}
            options={select_option?.states}
          />
        </Stack>
        <Stack sx={{ my: 2 }}>
          <InputLabel sx={{ ...labelSty }}>
            Which political party do you represent? <RequiredIcon />
          </InputLabel>
          <SelectInput
            value={select_option.party_id}
            onChange={(e) => handle_party(e.target.value)}
            options={select_option.party}
          />
        </Stack>

        <Stack sx={{ my: 1 }}>
          <InputLabel sx={{ ...labelSty }}>
            Which district do you represent? <RequiredIcon />
          </InputLabel>
          <SelectInput
            value={select_option?.district_id}
            onChange={(e: any) => handle_district(e.target.value)}
            options={select_option?.district}
          />
        </Stack>
        <Stack sx={{ my: 2 }}>
          <InputLabel sx={{ ...labelSty }}>
            Which constituency do you represent? <RequiredIcon />
          </InputLabel>
          <SelectInput
            value={select_option?.constituency_id}
            onChange={(e: any) => handle_constituent(e.target.value)}
            options={select_option?.constituent}
          />
        </Stack>

        <Stack sx={{ my: 2 }}>
          <InputLabel sx={{ ...labelSty }}>
            What’s your local government of primary residence? <RequiredIcon />
          </InputLabel>
          <SelectInput
            value={select_option.lga_id}
            onChange={(e) => handle_lga(e.target.value)}
            options={select_option.lga}
          />
        </Stack>

        <InputLabel sx={{ ...labelSty }}>
          Official social media handles <RequiredIcon />
        </InputLabel>
        <Typography variant="caption" sx={{ color: "#7991A4" }}>
          At least one <RequiredIcon />
        </Typography>
        <Stack sx={{ my: 1 }}>
          <InputCustom
            placeholder={"Website (optional)"}
            value={social_links.value_1}
            onchange={(e: any) =>
              setSocial_Links((prev) => ({ ...prev, value_1: e.target.value }))
            }
            type={"text"}
            size={"medium"}
            styles={{}}
          />
        </Stack>
        <Stack sx={{ my: 1 }}>
          <InputCustom
            placeholder={"X (Twitter) optional"}
            value={social_links.value_2}
            onchange={(e: any) =>
              setSocial_Links((prev) => ({ ...prev, value_2: e.target.value }))
            }
            type={"text"}
            size={"medium"}
            styles={{}}
          />
        </Stack>
        <Stack sx={{ my: 1 }}>
          <InputCustom
            placeholder={"LinkedIn (optional)"}
            value={social_links.value_3}
            onchange={(e: any) =>
              setSocial_Links((prev) => ({ ...prev, value_3: e.target.value }))
            }
            type={"text"}
            size={"medium"}
            styles={{}}
          />
        </Stack>
        <Stack sx={{ width: "100%", mt: 1, mb: 5 }}>
          <InputLabel sx={{ ...labelSty }}>
            When were you officially sworn into office? <RequiredIcon />
          </InputLabel>
          <CustomDatePicker
            value={selectedDate}
            onChange={handle_date}
            label={"Select date"}
          />
        </Stack>
        <Stack
          direction={"row"}
          justifyContent={"center"}
          sx={{
            position: "fixed",
            bottom: 4,
            width: isMedium ? "80%" : 500,
            p: 2,
            background:
              "linear-gradient(0deg, #FAFAFA 37.99%, rgba(250, 250, 250, 0.5) 94.97%)",
          }}
        >
          <Button
            variant="contained"
            onClick={on_submit}
            sx={{ ...btnStyOne, width: isMedium ? "100%" : "80%" }}
          >
            Continue
          </Button>
        </Stack>
      </Box>
    </Box>
  );
};
